import { FunctionReturnType } from 'convex/server';
import { api } from 'convex/_generated/api';

export type Plant = FunctionReturnType<typeof api.plants.queries.getAllPlants>[number];

/** True when a catalog image should be shown instead of the emoji fallback. */
export function hasPlantImage(imagePath?: string): boolean {
  if (!imagePath) return false;
  return !imagePath.includes('/placeholder');
}

export function canEditPlant(plant: Plant): boolean {
  return plant.isUserOwned === true;
}

export function filterPlantsBySearch(plants: Plant[], query: string): Plant[] {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return plants;
  return plants.filter(
    (plant) =>
      plant.name.toLowerCase().includes(trimmed) ||
      plant.category.toLowerCase().includes(trimmed) ||
      plant.speciesName.toLowerCase().includes(trimmed)
  );
}

export function filterPlantsByCategory(plants: Plant[], category: string | null): Plant[] {
  if (!category) return plants;
  return plants.filter((plant) => plant.category === category);
}

export function sortPlantsForDisplay(plants: Plant[]): Plant[] {
  return [...plants].sort((a, b) => {
    if (a.isUserOwned && !b.isUserOwned) return -1;
    if (!a.isUserOwned && b.isUserOwned) return 1;
    const categoryCompare = a.category.localeCompare(b.category);
    if (categoryCompare !== 0) return categoryCompare;
    return a.name.localeCompare(b.name);
  });
}

export function getPlantName(plants: Plant[], plantId: string | null): string | undefined {
  if (!plantId) return undefined;
  return plants.find((plant) => plant.id === plantId)?.name;
}

export function getDefaultCategory(categories: string[]): string {
  if (categories.length === 0) return 'Other';
  return categories.includes('Vegetables') ? 'Vegetables' : categories[0];
}

export function getVisiblePlants(
  plants: Plant[],
  searchQuery: string,
  selectedCategory: string | null
): Plant[] {
  return sortPlantsForDisplay(
    filterPlantsByCategory(filterPlantsBySearch(plants, searchQuery), selectedCategory)
  );
}
